import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react';

export function NoteRowActions({
  showEdit,
  showDelete,
  busy,
  editLabel,
  deleteLabel,
  onEdit,
  onDelete,
}: {
  showEdit: boolean;
  showDelete: boolean;
  busy: boolean;
  editLabel: string;
  deleteLabel: string;
  onEdit: () => void;
  onDelete: () => void;
}) {
  if (!showEdit && !showDelete) return null;
  return (
    <>
      {showEdit && (
        <button
          type="button"
          className="rounded p-0.5 text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-50"
          aria-label={editLabel}
          disabled={busy}
          onClick={onEdit}
        >
          <PencilSimpleIcon className="h-3 w-3" />
        </button>
      )}
      {showDelete && (
        <button
          type="button"
          className="rounded p-0.5 text-muted-foreground hover:bg-destructive/10 hover:text-destructive disabled:opacity-50"
          aria-label={deleteLabel}
          disabled={busy}
          onClick={onDelete}
        >
          <TrashIcon className="h-3 w-3" />
        </button>
      )}
    </>
  );
}
